/* pcc-page.js: hides the sticky bar while a main buy button is on screen */
(function () {
  var bar = document.querySelector('[data-pcc-bar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var seen = [];
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var i = seen.indexOf(e.target);
      if (e.isIntersecting && i < 0) seen.push(e.target);
      if (!e.isIntersecting && i > -1) seen.splice(i, 1);
    });
    bar.classList.toggle('pcc-bar--hide', seen.length > 0);
  }, { threshold: 0.6 });
  [].slice.call(document.querySelectorAll('[data-pcc-cta]')).forEach(function (t) { io.observe(t); });
})();